// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { toast } from 'react-toastify';
import ToastMessage from './ToastMessage';

const TOAST_CLASS = {
  success: 'wurqly-toast wurqly-toast--success',
  error: 'wurqly-toast wurqly-toast--error',
  pending: 'wurqly-toast wurqly-toast--pending',
  warning: 'wurqly-toast wurqly-toast--warning',
  info: 'wurqly-toast wurqly-toast--pending',
};

const TOAST_AUTO_CLOSE_MS = 4000;

const baseOptions = {
  closeButton: false,
  hideProgressBar: true,
  icon: false,
  bodyClassName: 'wurqly-toast__body',
  autoClose: TOAST_AUTO_CLOSE_MS,
};

const showNotification = (type, event = {}) => {
  const content = <ToastMessage type={type} event={event} />;
  const className = TOAST_CLASS[type] || TOAST_CLASS.info;

  switch (type) {
    case 'success':
      toast.success(content, { ...baseOptions, className });
      break;
    case 'error':
      toast.error(content, { ...baseOptions, className });
      break;
    case 'warning':
      toast.warn(content, { ...baseOptions, className });
      break;
    case 'pending':
    case 'info':
    default:
      toast.info(content, { ...baseOptions, className });
      break;
  }
};

export default showNotification;
